import {
  useMutation,
  UseMutationResult,
  useQuery,
  useQueryClient,
  UseQueryResult,
} from '@taxdown/zeno-sama-query';
import i18n from 'Services/i18n';
import NotificationService, { AlertTypes } from 'Services/notification';
import RecordsService from 'Services/records';
import TaxService from 'Services/tax';
import { store } from 'Store';
import { setIsNotLoadingAction } from 'Store/modules/app/actions';
import { AccountQueryKey } from 'Containers/Account/components/AccountProfile/types';
import { seasonsSelector } from 'Containers/Dashboard/hooks';
import { TAX_YEAR } from 'Config';
import { QueryKeys, RecordType, ResponseType, SeasonFiltered } from 'Types/common';
import { SKIP_POLLING_STAGES } from './utils';

export const usePatchClabeUser = (): UseMutationResult<ResponseType<RecordType>> => {
  const queryClient = useQueryClient();

  return useMutation([QueryKeys.PATCH_CLABE_USERS], RecordsService.setFiledInfo, {
    onSuccess: () => {
      NotificationService.sendNotification(i18n.t('common:Patch.filing.user'), AlertTypes.success);
      queryClient.resetQueries([AccountQueryKey.GET_CLABE]);
      queryClient.resetQueries([QueryKeys.FETCH_SEASONS]);
      queryClient.resetQueries([QueryKeys.GET_PLAN_FLEX_INVOICE]);
      queryClient.resetQueries([QueryKeys.FETCH_NEW_SEASONS]);
    },
  });
};

export const getUserStage = (userStage: string | null, data?: SeasonFiltered[]): boolean => {
  if (!data) {
    return false;
  }
  const tax = data?.find(item => item.taxYear.toString() === TAX_YEAR);
  return tax?.stage !== userStage;
};

export const useFetchNewSeasons = (
  callHook: boolean,
  userStage: string | null,
  hideModal: () => void
): UseQueryResult<SeasonFiltered[]> => {
  const queryClient = useQueryClient();
  return useQuery([QueryKeys.FETCH_NEW_SEASONS], TaxService.getSeasons, {
    select: seasonsSelector,
    onSuccess: data => {
      if (userStage && (getUserStage(userStage, data) || SKIP_POLLING_STAGES.includes(userStage))) {
        queryClient.resetQueries([QueryKeys.FETCH_SEASONS]);
        store.dispatch(setIsNotLoadingAction());
        hideModal();
      }
    },
    refetchInterval: data => {
      if (userStage && (getUserStage(userStage, data) || SKIP_POLLING_STAGES.includes(userStage)))
        return false;
      return 500;
    },
    enabled: callHook,
    staleTime: 3000,
    cacheTime: 0,
  });
};
